import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
import { useStylesheet } from "../../../contexts/stylesheet.js";
const Group = (param)=>{
    let { headline, borderless, children, legend, ...rest } = param;
    const { Group, GroupInner, GroupDescription, screenReaderOnlyClass } = useStylesheet().extend(...extendCommonGroupsStylesheet);
    const useLegend = legend ? legend : typeof headline === "string" ? headline : undefined;
    const inner = /*#__PURE__*/ _jsxs(GroupInner, {
        children: [
            useLegend && /*#__PURE__*/ _jsx("legend", {
                className: screenReaderOnlyClass,
                children: useLegend
            }),
            /*#__PURE__*/ _jsx("span", {
                "aria-hidden": !!useLegend,
                children: headline
            }),
            children && /*#__PURE__*/ _jsx(GroupDescription, {
                children: children
            })
        ]
    });
    return borderless ? /*#__PURE__*/ _jsx("div", {
        className: "group",
        ...rest,
        children: inner
    }) : /*#__PURE__*/ _jsx(Group, {
        ...rest,
        children: inner
    });
};
export { Group };
